<div>
  <h1 mat-dialog-title>{{ dialogTitle }}</h1>
  <div class="body">
    {{ dialogMessage }}
  </div>
  <div mat-dialog-actions>
    <mat-progress-bar mode="query"></mat-progress-bar>
  </div>
</div>